package br.com.heyagenda.domain.usecase

import br.com.heyagenda.domain.model.Appointment
import br.com.heyagenda.domain.repository.AppointmentRepository
import kotlinx.coroutines.flow.Flow

class GetAppointmentsForDateUseCase(
    private val repository: AppointmentRepository
) {
    operator fun invoke(dateIso: String): Flow<List<Appointment>> {
        return repository.getAppointmentsForDate(dateIso)
    }
}
